import Validator from 'components/validation.js';

export default function TeaserValidator() {
  new Validator().initOnDomReady("form#newsletterTeaserForm");
  new Validator().initOnDomReady("form#newsletter-layer-form");
}


